import React from 'react';
import { Badge } from '@/components/ui/badge';

type TicketSectionProps = React.PropsWithChildren<{
  title: string;
  /** Right-aligned count pill, e.g. the outstanding need across requirements. */
  count?: string | number;
  /** "Add Requirement" / "Add row" / "Add link" lives here. */
  actions?: React.ReactNode;
  description?: string;
}>;

/**
 * One titled block in the ticket's main column. Kept dumb so the three row
 * editors differ only in their rows.
 */
export const TicketSection: React.FC<TicketSectionProps> = ({
  title,
  count,
  actions,
  description,
  children,
}) => (
  <section className="tw:rounded-lg tw:border tw:border-border tw:p-3">
    <div className="tw:mb-2 tw:flex tw:flex-wrap tw:items-center tw:justify-between tw:gap-2">
      <div className="tw:flex tw:min-w-0 tw:items-center tw:gap-2">
        <h4 className="tw:m-0 tw:text-xs tw:font-semibold tw:tracking-wide tw:uppercase tw:text-muted-foreground">
          {title}
        </h4>
        {count !== undefined && count !== '' && (
          <Badge
            variant="count-outline"
            className="tw:h-4 tw:self-center tw:px-1.5 tw:leading-none"
          >
            {count}
          </Badge>
        )}
      </div>
      {actions}
    </div>
    {description && (
      <p className="tw:mb-2 tw:text-xs tw:text-muted-foreground">
        {description}
      </p>
    )}
    {children}
  </section>
);
